// ⚡️ DRAG DROP OVERLAY: Drag & drop visual feedback
// Extracted from ChatPanel.js for better organization and reusability

import React from 'react';

const DragDropOverlay = ({ isDragOver, isDarkMode }) => {
  if (!isDragOver) return null;

  return (
    <div className={`absolute inset-0 bg-opacity-90 flex items-center justify-center z-10 rounded-lg ${
      isDarkMode ? 'bg-blue-900/50' : 'bg-blue-50'
    }`}>
      <div className="text-center">
        <div className="text-4xl mb-2">📁</div>
        <div className={`text-lg font-semibold ${
          isDarkMode ? 'text-blue-300' : 'text-blue-600'
        }`}>Drop your file here</div>
        <div className={`text-sm ${
          isDarkMode ? 'text-blue-400' : 'text-blue-500'
        }`}>Images and videos supported</div>
      </div>
    </div>
  );
};

export default DragDropOverlay;
